import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { RegisterAction } from '@ih/app/client/register/data-access';
import {
  GetMe,
  LoggedInAction,
  MenuDisplayState,
  SetUserAction,
} from '@ih/app/client/shared/states';
import { Platform } from '@ionic/angular';
import {
  Actions,
  ofActionCompleted,
  ofActionSuccessful,
  Select,
  Store,
} from '@ngxs/store';
import { Observable, Subject, take, takeUntil, tap } from 'rxjs';

@Component({
  selector: 'ih-app-go-shell-feature',
  template: `
    <ion-app class="safe-area-inset-top-root safe-area-inset-bottom-root">
      <ion-split-pane contentId="main">
        <ion-menu
          contentId="main"
          menuId="main"
          [ngClass]="(showMenu$ | async) === false ? 'hide-menu' : ''"
        >
          <ih-app-client-shared-components-menu-header-ui></ih-app-client-shared-components-menu-header-ui>
          <ion-content>
            <ih-app-client-shared-components-menu-content-feature
              menuId="main"
              [enableLogout]="true"
            ></ih-app-client-shared-components-menu-content-feature>
          </ion-content>
        </ion-menu>
        <ion-router-outlet id="main"></ion-router-outlet>
      </ion-split-pane>
    </ion-app>
  `,
  styles: [
    `
      .hide-menu {
        display: none;
      }
    `,
  ],
  standalone: false,
})
export class AppGoShellFeatureComponent implements OnInit, OnDestroy {
  private readonly store = inject(Store);
  private readonly actions$ = inject(Actions);
  private readonly platform = inject(Platform);

  @Select(MenuDisplayState.showMenu) showMenu$!: Observable<boolean>;

  private ngUnsubscribe = new Subject<void>();

  constructor() {
    // Safe area is not computed correctly for Android
    const isAndroid = this.platform.is('android');
    // if (isAndroid){
    import('@capacitor-community/safe-area').then((module) => {
      const { SafeArea } = module;
      const prefersDark = window.matchMedia(
        '(prefers-color-scheme: dark)',
      ).matches;

      SafeArea.enable({
        config: {
          customColorsForSystemBars: true,
          statusBarColor: '#00000000', // transparent
          statusBarContent: prefersDark ? 'light' : 'dark',
          navigationBarColor: '#00000000', // transparent
          navigationBarContent: prefersDark ? 'light' : 'dark',
          offset: 0,
        },
      });
    });
  }

  ngOnInit() {
    this.actions$
      .pipe(
        ofActionCompleted(LoggedInAction),
        tap(() => {
          this.actions$
            .pipe(
              ofActionCompleted(SetUserAction),
              tap(() => {
                const registering = this.store.selectSnapshot<boolean>(
                  (state) => state.authentication.registering,
                );

                if (registering) {
                  this.actions$
                    .pipe(
                      ofActionSuccessful(RegisterAction),
                      tap(() => {
                        this.store.dispatch(new GetMe());
                      }),
                      take(1),
                    )
                    .subscribe();
                } else {
                  this.store.dispatch(new GetMe());
                }
              }),
              take(1),
            )
            .subscribe();
        }),
        takeUntil(this.ngUnsubscribe),
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
